import { useAppSelector } from '../../app/hooks';
import {
  selectAutoComboCartItems,
  selectAutoComboCartItemsQuantity,
} from '../../redux/features/autoCombo/autoCombo.selector';
import {
  selectFeatureFlagAutoCombo,
  selectFeatureFlagBMAutoCombo,
} from '../../redux/features/config/config.selector';
import { getMenuUnificationFeatureFlag } from '../../utils/session-storage';

const useAutoCombo = () => {
  const autoCombinedCartItems = useAppSelector(selectAutoComboCartItems);
  const autoCombinedCartItemsQuantity = useAppSelector(
    selectAutoComboCartItemsQuantity
  );

  const isUnifiedMenu = getMenuUnificationFeatureFlag();
  const isBMAutoComboEnabled = useAppSelector(selectFeatureFlagBMAutoCombo);
  const isPRPAutoComboEnabled = useAppSelector(selectFeatureFlagAutoCombo);

  const isAutoComboEnabled =
    isPRPAutoComboEnabled || (isUnifiedMenu && isBMAutoComboEnabled);

  const areItemsAutoCombined =
    isAutoComboEnabled && Object.values(autoCombinedCartItems).length > 0;

  return {
    isUnifiedMenu,
    isPRPAutoComboEnabled,
    isBMAutoComboEnabled,
    isAutoComboEnabled,
    areItemsAutoCombined,
    autoCombinedCartItems,
    autoCombinedCartItemsQuantity,
  };
};

export default useAutoCombo;
